/* eslint-disable */
export default {
  conferenceCall: 'Telefonkonferenz',
  onHold: 'Wird gehalten',
  ongoing: 'Fortlaufend',
  unknown: 'Unbekannt',
  disconnected: 'Getrennt',
  loading: 'Ladevorgang läuft…',
  loadingTimeout: 'Zeitüberschreitung beim Laden.',
} as const;

// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"ongoing"@#@ @source: @#@"Ongoing"@#@
// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"disconnected"@#@ @source: @#@"Disconnected"@#@
// @key: @#@"loading"@#@ @source: @#@"Loading ..."@#@
// @key: @#@"loadingTimeout"@#@ @source: @#@"Loading timeout."@#@
